
import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import * as Consts from "../../ts/rlAdmin.consts";
import { NotifyService } from "../../services/notify-service";
import { DocGenConfigService } from "../../services/doc-gen-config-service";
import { EntityConfigService } from "../../services/entity-config-service";
import { EntityService } from "../../services/entity-service";
import { AclService } from "../../services/acl-service";
import * as angular from "angular";

export class DocGenConfigController {
	static $inject = ["$scope", "$window", "docGenConfigService", "notifyService", "$q", "entityConfigService", "entityService", "aclService"];
	editMode: boolean;
	docTypes: Models.IWFDocumentTemplateType[];         //dropdown values
	selectedDocType: Models.IWFDocumentTemplateType;    //selected item from dropdown
	docTemplateList: Models.IDocTemplateConfig[];       //list of templates based on dropdown
	selectedDocTemplate: Models.IDocTemplateConfig;     //selected template - or editing
	templateList: { [key: number]: string };            //name of exising templates to prevent duplicate names
	docTypeID: number;                                  //from init, for navigation
	charTypeTemplates: Models.ICharacteristicTemplate[];           //all available char templates for selected type
	selectedCharTemplateIDs: number[];                  //templates selected - in edit mode
	pickedFile: Models.IFilestackPickFile[];
	selectedFileName: string;
	charTypes: Models.ICharacteristicType[];
	selectedCharTypeID: number;
	createDocTemplateCharTypeID: number;
	fileUploaded: boolean;
	draftTemplateHasErrors: boolean;
	draftTemplateErrors: string[];

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private docGenConfigService: DocGenConfigService,
		private notifyService: NotifyService, private $q: ng.IQService, private entityConfigService: EntityConfigService,
		private entityService: EntityService, private aclService: AclService) {
		this.editMode = false;
		this.docTypes = [];
		this.selectedDocTemplate = <Models.IDocTemplateConfig>{};
		this.selectedDocTemplate.doc = <Models.IDocTemplate>{};
		this.docTemplateList = [];
		this.selectedDocType = null;
		this.templateList = {};
		this.docTypeID = 0;
		this.pickedFile = null;
		this.charTypeTemplates = [];
		this.selectedCharTemplateIDs = [];
		this.charTypes = [];
		this.selectedCharTypeID = null;
		this.charTypeTemplates = [];
		this.createDocTemplateCharTypeID = 0;
		this.fileUploaded = false;
		this.draftTemplateHasErrors = false;
		this.draftTemplateErrors = [];

		this.$scope.$watch(() => this.pickedFile,
			(newValue, oldValue) => {
				if (newValue != oldValue && newValue != null) {
					this.selectedFileName = newValue[0].filename;
					this.fileUploaded = true;
					notifyService.notifySuccess("File Uploaded");
				}
			}, true);

		this.$scope.$watch(() => this.docTypes, (oldValue: Models.IWFDocumentTemplateType[], newValue: Models.IWFDocumentTemplateType[]) => {
			if (oldValue != newValue) {
				//for navigation - from init
				if (this.docTypeID > 0) {
					//this.SetDocType(this.docTypeID);
					this.docTypeID = 0;
				}
			}
		});

		this.$scope.$watch(() => this.selectedDocType, (oldValue: Models.IWFDocumentTemplateType, newValue: Models.IWFDocumentTemplateType) => {
			if (oldValue != newValue) {
				//this.LoadCharacteristicTemplates(this.selectedDocType.templateTypeID);
			}
		});

		this.$scope.$watch(() => this.docTemplateList, (oldValue: Models.IDocTemplateConfig[], newValue: Models.IDocTemplateConfig[]) => {
			if (oldValue != newValue) {
				this.SetTemplateList();
			}
		});

		this.$scope.$watch(() => this.selectedCharTypeID, (newValue, oldValue) => {
			if (newValue != oldValue && newValue > 0) {
				this.LoadDocTemplates(this.selectedCharTypeID);
			}
		});

	}

	Init(docTypeID: number) {
		this.docTypeID = docTypeID;
		this.LoadCharTypes();
	}

	LoadCharacteristicTemplates(charTypeID: number) {
		this.notifyService.startProgress();
		return this.entityConfigService.getCharacteristicTemplates(charTypeID)
			.then((result) => {
				this.charTypeTemplates = _.filter(result, r => Utils.AclUtil.hasCreateAccess(this.aclService.acls, r.acl));
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadCharTypes(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.entityConfigService.getCharacteristicTypes()
			.then((result) => {
				this.charTypes = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadCharTypeTemplatesForDocumentTemplate(docTemplateID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.docGenConfigService.getSelectedCharTypeTemplatesForDoc(docTemplateID)
			.then((result) => {
				this.selectedCharTemplateIDs = result;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	LoadDocTemplates(charTypeID: number) {
		this.notifyService.startProgress();
		var promise1 = this.docGenConfigService.getDocTemplatesByCharType(charTypeID)
			.then((result) => {
				this.docTemplateList = result;
			});
		var promise2 = this.LoadCharacteristicTemplates(charTypeID);
		this.$q.all([promise1, promise2])
			.then(() => {
				this.notifyService.endProgress();
			});
	}

	SetTemplateList() {
		this.templateList = {};
		_.forEach(this.docTemplateList, r => {
			if (this.selectedDocTemplate.doc.documentTemplateID != r.doc.documentTemplateID) {
				this.templateList[r.doc.documentTemplateID] = r.doc.templateLabel;
			}
		});
	}

	ResetEditForm() {
		this.selectedCharTemplateIDs = [];
		this.selectedFileName = null;
		this.pickedFile = null;
	}

	Cancel(form: ng.IFormController) {
		this.ResetEditForm();
		form.$setPristine();
		this.editMode = false;
		this.notifyService.broadcastDone();
	}

	Edit(doc: Models.IDocTemplateConfig) {
		this.selectedDocTemplate = angular.copy(doc);
		this.LoadCharTypeTemplatesForDocumentTemplate(this.selectedDocTemplate.doc.documentTemplateID)
			.then(() => {
				this.selectedFileName = doc.doc.fileName;
				this.createDocTemplateCharTypeID = this.selectedCharTypeID;
				this.editMode = true;
				this.fileUploaded = true;
			});
	}

	Create(charType: Models.ICharacteristicType) {
		this.notifyService.startProgress();
		return this.LoadCharacteristicTemplates(charType.charTypeID)
			.then(() => {
				this.selectedDocTemplate = <Models.IDocTemplateConfig>{};
				this.selectedDocTemplate.doc = <Models.IDocTemplate>{};
				this.selectedDocTemplate.doc.documentTemplateID = 0;
				this.createDocTemplateCharTypeID = charType.charTypeID;
				this.editMode = true;
				this.fileUploaded = false;
			}).finally(() => {
				this.notifyService.endProgress();
			});
	}

	//after save, relate attachment to new inventory record and move it from temp bucket
	MoveAttachmentFromTempAttachment(): ng.IPromise<any> {
		var request: Models.IDocGenAttachmentRequest = {
			path: this.pickedFile[0].key,
			fileName: this.pickedFile[0].filename,
			charTypeID: this.createDocTemplateCharTypeID,
			documentTemplateID: this.selectedDocTemplate.doc.documentTemplateID
		};
		return this.docGenConfigService.saveAttachment(request)
			.then(() => { this.notifyService.notifySuccess("Attachment Saved."); },
			() => {
				this.notifyService.notifyError("There was an error saving the attachment.");
			});
	}

	Save(form: ng.IFormController) {
		if (form.$valid) {
			this.notifyService.startProgress();
			var fileName = "";
			if (this.pickedFile != null) {
				fileName = this.pickedFile[0].key
			}
			else {
				fileName = this.selectedFileName;
			}

			var docTemplateValidationRequest: Models.IDocTemplateValidationRequest = {
				fileName: fileName
			}

			this.docGenConfigService.validateDraftTemplate(docTemplateValidationRequest)
				.then((templateValidationResult) => {
					this.draftTemplateHasErrors = false;
					this.draftTemplateErrors = [];
					this.draftTemplateHasErrors = !templateValidationResult.valid;
					this.draftTemplateErrors = templateValidationResult.errors;
					var req = <Models.IDocTemplateSaveRequest>{};
					req.doc = this.selectedDocTemplate.doc;
					req.charTypeID = this.createDocTemplateCharTypeID;
					req.doc.fileName = this.selectedFileName
					req.doc.templateDescription = this.selectedDocTemplate.doc.templateDescription;
					req.selectedTemplateIDs = this.selectedCharTemplateIDs;

					return this.docGenConfigService.saveTemplate(req)
						.then((result) => {
							var promises = [];
							if (!_.isNull(this.pickedFile)) {
								this.selectedDocTemplate.doc.documentTemplateID = result.data;
								promises.push(this.MoveAttachmentFromTempAttachment());
							}
							return this.$q.all(promises)
								.then(() => {
									this.notifyService.broadcastDone();
									form.$setPristine();
									this.ResetEditForm();
									this.editMode = false;
									this.notifyService.notifySuccess("Template saved successfully");
									this.createDocTemplateCharTypeID = 0;
									this.LoadDocTemplates(this.selectedCharTypeID);
								});
						}).finally(() => {
							this.notifyService.endProgress();
						});
				});
		}
	}

	Delete(docTemplateID: number) {
		if (this.$window.confirm("Are you sure you want to Delete this Document Template?")) {
			this.notifyService.startProgress();
			var request = <Models.IDocTemplateRequest>{};
			request.docTemplateID = docTemplateID;
			request.charTypeID = this.selectedCharTypeID;
			return this.docGenConfigService.deleteDocTemplate(request)
				.then(() => {
					this.notifyService.notifySuccess("Document Template deleted");
					this.LoadDocTemplates(this.selectedCharTypeID);
				}).finally(() => {
					this.notifyService.endProgress();
				});
		}
		else {
			this.notifyService.broadcastDone();
		}
	}
}
